import "./Spinner.scss";

export const Spinner = ({ size = "medium" }: { size?: "small" | "medium" | "large" }) => {
  return <div className={`spinner-style ${size}`} />;
};
